import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import daLocale from 'react-intl/locale-data/da';
import deLocale from 'react-intl/locale-data/de';
import enLocale from 'react-intl/locale-data/en';
import esLocale from 'react-intl/locale-data/es';
import etLocale from 'react-intl/locale-data/et';
import fiLocale from 'react-intl/locale-data/fi';
import frLocale from 'react-intl/locale-data/fr';
import itLocale from 'react-intl/locale-data/it';
import nlLocale from 'react-intl/locale-data/nl';
import noLocale from 'react-intl/locale-data/no';
import ptLocale from 'react-intl/locale-data/pt';
import ruLocale from 'react-intl/locale-data/ru';
import svLocale from 'react-intl/locale-data/sv';
import { modelOf } from '../../prop-types';
import LanguageStore from '../../store/LanguageStore';
import TranslationStore from '../../store/TranslationStore';
import daMessages from '../messages/da.json';
import deMessages from '../messages/de.json';
import enMessages from '../messages/en.json';
import esMessages from '../messages/es.json';
import etMessages from '../messages/et.json';
import fiMessages from '../messages/fi.json';
import frMessages from '../messages/fr.json';
import itMessages from '../messages/it.json';
import nlMessages from '../messages/nl.json';
import noMessages from '../messages/no.json';
import ptMessages from '../messages/pt.json';
import ruMessages from '../messages/ru.json';
import svMessages from '../messages/sv.json';

addLocaleData([
  ...daLocale,
  ...deLocale,
  ...enLocale,
  ...esLocale,
  ...etLocale,
  ...fiLocale,
  ...frLocale,
  ...itLocale,
  ...nlLocale,
  ...noLocale,
  ...ptLocale,
  ...ruLocale,
  ...svLocale,
]);
const validLanguages = [
  'da',
  'de',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'it',
  'nl',
  'no',
  'pt',
  'ru',
  'sv',
];

@observer
export class IntlWrapper extends Component {
  constructor(props) {
    super(props);

    this.translations = {
      da: daMessages,
      de: deMessages,
      en: enMessages,
      es: esMessages,
      et: etMessages,
      fi: fiMessages,
      fr: frMessages,
      it: itMessages,
      nl: nlMessages,
      no: noMessages,
      pt: ptMessages,
      ru: ruMessages,
      sv: svMessages,
    };
  }

  render() {
    const {
      languageStore,
      translationStore,
      overrideLocale,
      loadableMessages,
    } = this.props;

    const locale =
      !!overrideLocale && validLanguages.includes(overrideLocale)
        ? overrideLocale
        : languageStore.activeLocale;
    const appMessages = this.translations[locale] || this.translations.en;
    let extraMessages;
    if (loadableMessages) {
      extraMessages = loadableMessages[locale] || loadableMessages.en;
    }

    // Override messages with those provided by the backend
    // Extra messages include translations that are not needed by default and should be lazy loaded at some point.
    const messages = {
      ...appMessages,
      ...translationStore.messages,
      ...extraMessages,
    };

    // The locale and translation are both loaded only at the start of the page load. Lazy loading will be added later.
    // Locale changes from the UI will reload the page to make sure the new locale is loaded fully.
    return (
      <IntlProvider locale={locale} messages={messages}>
        {this.props.children}
      </IntlProvider>
    );
  }
}

IntlWrapper.propTypes = {
  languageStore: modelOf(LanguageStore).isRequired,
  translationStore: modelOf(TranslationStore).isRequired,
  loadableMessages: PropTypes.object,
  overrideLocale: PropTypes.string,
};

export default IntlWrapper;
